import { UpdateGlobalParameterDto } from "../api/api-types";
import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export type WoodboxProps = {
  woodBoxesPrice?: UpdateGlobalParameterDto["woodBoxesPrice"];
};

export type WoodboxPriceGroup = {
  region: string;
  bottleVolume: number;
  items: UpdateGlobalParameterDto["woodBoxesPrice"];
};

export const UpdateWoodboxesPriceSchema = z.array(
  z.object({
    id: z.string(),
    bottleVolume: z
      .number({
        coerce: true,
        required_error: i18nMessage("shared:forms.woodboxPrice.bottleVolumeRequired"),
        message: i18nMessage("shared:forms.woodboxPrice.bottleVolumeRequired"),
      })
      .min(0, i18nMessage("shared:forms.woodboxPrice.bottleVolumeRequired")),
    bottleQuantity: z
      .number({
        coerce: true,
        required_error: i18nMessage("shared:forms.woodboxPrice.bottleQuantityRequired"),
        message: i18nMessage("shared:forms.woodboxPrice.bottleQuantityRequired"),
      })
      .min(0, i18nMessage("shared:forms.woodboxPrice.bottleQuantityRequired")),
    price: z
      .number({
        coerce: true,
        required_error: i18nMessage("shared:forms.woodboxPrice.priceRequired"),
        message: i18nMessage("shared:forms.woodboxPrice.priceRequired"),
      })
      .min(0, i18nMessage("shared:forms.woodboxPrice.priceRequired")),
    region: z.enum(["EUROPE", "EUROPEANUNION", "OTHER", "FRANCE"], {
      required_error: i18nMessage("shared:forms.woodboxPrice.regionRequired"),
      message: i18nMessage("shared:forms.woodboxPrice.regionRequired"),
    }),
    globalParametersId: z.string().optional(),
    companyId: z.string().optional(),
  }),
);

export type UpdateWoodboxesPriceFormData = z.infer<typeof UpdateWoodboxesPriceSchema>;
